import {Injectable} from '@angular/core';
import {HandlerService} from '../comunicator-native/handler/handler';
import {RadioModel} from '../../../personal-data/model/radio.model';
import {DomainDataService} from './domain-data.service';
import {DomainDataType} from './model/domain-data-type';
import {DomainOrigin} from "./model/domain-origin";
import {DomainUtil} from "./domain-util";

@Injectable({
  providedIn: 'root'
})
export class DomainDataMobileService implements DomainDataService{

  private readonly domainTypes = [
    {domainDataType: DomainDataType.DocumentType, domainId:19},
    {domainDataType: DomainDataType.City, domainId:9999999999},
    {domainDataType: DomainDataType.Country, domainId:84},
    {domainDataType: DomainDataType.Gender, domainId:29},
    {domainDataType: DomainDataType.DocumentIssuing, domainId: 13},
    {domainDataType: DomainDataType.MaritalStatus, domainId: 23},
    {domainDataType: DomainDataType.OriginIncome, domainId:469},
    {domainDataType: DomainDataType.Profession, domainId:28},
    {domainDataType: DomainDataType.State, domainId:45},
    {domainDataType: DomainDataType.Nationality, domainId:24}
  ]

  constructor(private handlerService: HandlerService) { }

  public async getDomains(domainDataType: DomainDataType, parameter?: any): Promise<RadioModel[]> {
    const dataCache = DomainUtil.getDomainFromCache(this.getOrigin(), domainDataType);

    if(dataCache && dataCache.length>0){
      return Promise.resolve(dataCache);
    }
    else {
      return this.getDataFromRemote(domainDataType, parameter).then((domains) =>{
        DomainUtil.saveDomainInCache(this.getOrigin(), domainDataType, domains);
        return Promise.resolve(domains);
      }).catch((err) =>{
        return Promise.reject();
      })

    }
  }


  private async getDataFromRemote(domainDataType: DomainDataType, parameter?: any): Promise<RadioModel[]> {
    const domainId = this.domainTypes.find(r=> r.domainDataType===domainDataType).domainId;
    const relCaronte = 'user-domains';
    const dataCaronte = { domainId: domainId.toString() };
    return this.handlerService.caronteCommunicator(relCaronte, null, dataCaronte).then((data: any) => {
      if (data && data.data && data.data.dominios) {
        return Promise.resolve(data.data.dominios.map(toRadioModel));
      } else {
        return Promise.reject();
      }
    }).catch((err) =>{
      return Promise.reject();
    })
  }

  getOrigin(): DomainOrigin {
    return DomainOrigin.UserDomainMobile;
  }
}

function toRadioModel(item){
  return new RadioModel(
      item.codigo,
      item['valor-resumido'],
      item['valor-resumido'],
    );
}
